import {
  GetXsrfToken,
  SetXsrfToken,
  GetAuthorizationIdToken,
} from '~utils/sessionStorage'
import { getTokenSilentRedirect } from '~utils/msal/msalAuthentication'

export type FetchAPI = WindowOrWorkerGlobalScope['fetch'];

/**
 * Extended fetch API method to handles:
 * - XSRF tokens
 */
const customFetchApi = (fetch: FetchAPI): FetchAPI => async(url: RequestInfo, init: RequestInit | undefined): Promise<Response> => {
  // msal helper function which puts the AuthorizationIdToken in session storage
  // handles expired & refresh tokens as well
  await getTokenSilentRedirect()

  const xsrfToken = GetXsrfToken()
  const azureAuthorizationIdToken = GetAuthorizationIdToken()

  const requestInit = {
    ...init,
    credentials: 'include' as const, // same-origin
    headers: {
      ...(init ? init.headers : undefined),
      ...(xsrfToken ? { 'X-XSRF-TOKEN': xsrfToken } : undefined),
      ...(azureAuthorizationIdToken ? { Authorization: azureAuthorizationIdToken } : undefined),
    },
  }

  // execute request
  const response = await fetch(url, requestInit)

  // check if we have a XSRF token in the http response header
  const newXsrfToken = response.headers.get('X-XSRF-TOKEN')
  if (newXsrfToken) SetXsrfToken(newXsrfToken)
  return response
}

export default customFetchApi
